import React from "react";
import {
  BlockText,
  blockSectionBodyWrapClass,
} from "../../../designSystem/projectBlocks";

/**
 * Each entry file exports two things:
 *   - `meta`            : the index card shown on /Writing (title, summary, date, tags)
 *   - default component : the body of the entry, rendered on /Writing/:slug
 *
 * The body sits inside the WritingEntry shell, which already provides the
 * page hero (title + summary + date) and the page shell. So the component
 * below should render *just* the inner content — no <main>, no extra wrappers.
 */
export const meta = {
  slug: "hello-world",
  title: "Hello.",
  summary:
    "A new corner of the site for short notes on computational design and the tools I build along the way.",
  date: "2026-05-20",
  tags: ["meta", "site"],
};

export default function Entry() {
  return (
    <>
      <BlockText
        className={blockSectionBodyWrapClass}
        paragraphs={[
          "I have wanted a place to write for a while — not a full publication, just a quiet shelf to leave short notes on. Things I learn while building, tools I am tinkering with, decisions that surprised me. Most entries will be a few paragraphs at most.",
          "The format is deliberately minimal. Each entry is a small React component that lives next to the rest of the design system, so it can use the same primitives as the project pages — figures, sequences, captions, grids — without re-inventing anything.",
          "If you want to follow along, the easiest way is to check back here every few weeks. RSS may come later.",
        ]}
      />
    </>
  );
}
